import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { usePortalScope } from "@/contexts/portalScope";

/**
 * Keeps the Active Brands list out of a one-brand portal.
 *
 * The nav entry is already dropped when scoped, but the route stays reachable
 * by a bookmark, the back button, or any redirect that still points at
 * `/affiliate/brands`. A list whose only row is the brand you are inside is
 * not worth a screen, so scoped affiliates go straight to that brand.
 *
 * Waits for scope to resolve before deciding: redirecting on the loading
 * default would bounce marketplace affiliates off their own brands list.
 */
export function ActiveBrandsRoute({ children }: { children: ReactNode }) {
  const { scope, isLoading } = usePortalScope();

  if (isLoading) return null;
  if (scope.isScoped && scope.homeBrandUsername) {
    return (
      <Navigate to={`/affiliate/brands/${scope.homeBrandUsername}`} replace />
    );
  }
  return <>{children}</>;
}
